import React from "react"

import { Outlet } from "react-router-dom"

export class Layout extends React.Component<{}, {}>
{
	render()
	{
		return (
			<Outlet />
		)
	}
}
